import React from "react";
import { Link } from "react-router-dom";
export default function MarriageLook() {
  const cards = [
    { title: "The Vow Ivory", image: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg" },
    { title: "Reception Tuxedo", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg" },
    { title: "Sangeet Sherwani", image: "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?crop=entropy&cs=srgb&fm=jpg" },
    { title: "Engagement Suit", image: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg" },
  ];
  return (
    <main data-testid="marriage-page">
      <section className="relative h-[60vh] overflow-hidden bg-black text-white">
        <img src="https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black" />
        <div className="relative z-10 sq-container h-full flex flex-col justify-end pb-16">
          <div className="sq-eyebrow text-white/70">Wedding & Ceremony</div>
          <h1 className="font-display text-5xl md:text-7xl mt-3 leading-[0.95]">Marriage Look</h1>
          <p className="text-white/80 mt-4 max-w-xl">Hand-cut suits, sherwanis and tuxedos for every chapter of the big day.</p>
        </div>
      </section>
      <section className="sq-container py-16 grid grid-cols-2 md:grid-cols-4 gap-5">
        {cards.map((c, i) => (
          <Link key={i} to="/bespoke" data-testid={`marriage-card-${i}`} className="group">
            <div className="aspect-[3/4] overflow-hidden"><img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
            <div className="font-display text-xl mt-3">{c.title}</div>
          </Link>
        ))}
      </section>
      <section className="bg-squire-jeans text-white py-12 text-center">
        <h2 className="font-display text-3xl md:text-5xl">Plan backwards from your event date.</h2>
        <p className="mt-3 text-white/80">Tell us when you say "I do." We'll plan delivery 7 days ahead.</p>
        <Link to="/contact" className="sq-btn-ghost-white mt-6 inline-flex">Plan with Concierge</Link>
      </section>
    </main>
  );
}
